import { Plus, FilePlus2 } from 'lucide-react'

interface HeaderProps {
  title: string
  onQuickAdd?: () => void
  /** Opens the full New task form, alongside Quick add (LXP-45). */
  onNewTask?: () => void
}

export function Header({ title, onQuickAdd, onNewTask }: HeaderProps) {
  return (
    <header className="header">
      <h1 className="header-title">{title}</h1>
      <div className="header-actions">
        {onNewTask && (
          <button
            className="btn btn-ghost btn-sm"
            onClick={onNewTask}
            type="button"
            title="Create a task with description, dates, people, links and files"
          >
            <FilePlus2 size={16} strokeWidth={2} />
            <span>Detailed task</span>
          </button>
        )}
        {onQuickAdd && (
          <button className="btn btn-primary btn-sm" onClick={onQuickAdd} type="button">
            <Plus size={16} strokeWidth={2} />
            <span>Add task</span>
          </button>
        )}
        <kbd className="mono kbd-chip">⌘K</kbd>
      </div>
    </header>
  )
}
